import { render, staticRenderFns } from "./SelectTipoPago.vue?vue&type=template&id=8f1f12dc&"
import script from "./SelectTipoPago.vue?vue&type=script&lang=js&"
export * from "./SelectTipoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports